import React from 'react';
import { getTaskStatusColor } from '../../api/tasks';

const TaskStatusBadge = ({ status, size = 'md' }) => {
  const statusColor = getTaskStatusColor(status);

  const getStatusLabel = (status) => {
    const labels = {
      pending: 'Pending',
      in_progress: 'In Progress',
      on_hold: 'On Hold',
      completed: 'Completed',
      cancelled: 'Cancelled',
      closed: 'Closed'
    };
    return labels[status] || status;
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium capitalize ${sizeClasses[size]}`}
      style={{
        backgroundColor: statusColor + '20',
        color: statusColor
      }}
    >
      {getStatusLabel(status)}
    </span>
  );
};

export default TaskStatusBadge;
